import { decryptResponseData, getEncryptTimestamp } from '@/helpers/decrypt-resimo-data';
import { Apartment } from '@/models/apartment.model';

class ResimoService {
    // eslint-disable-next-line class-methods-use-this
    public fetchData(apiUrl: string, apartmentSymbol: string) {
        const timestamp = getEncryptTimestamp();

        return fetch(apiUrl, {
            headers: {
                timestamp,
            },
        })
            .then(async (encryptedResponse) => {
                const responseAsText = await encryptedResponse.text();
                const decodedData = decryptResponseData<Array<Apartment>>(responseAsText, timestamp);

                return decodedData
                    .find((apartment) => apartment.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                    === apartmentSymbol.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
            });
    }
}

export default ResimoService;
